import { fetchData, apiURL, xeropanApiUrl, xeropanExchangeApiURL,
  classroomPaymentKey, getCurrencyExchange } from './api_helper';

const getExchangeRate = payload => new Promise(((resolve, reject) => {
  const endpointURL = `${xeropanExchangeApiURL}/1/currencies/get_rate_with_symbol?symbol=${payload}`;
  getCurrencyExchange(endpointURL).then((result) => {
    resolve(result.response);
  }).catch((error) => {
    reject(error);
  });
}));

const getProductList = () => new Promise(((resolve, reject) => {
  const endpointURL = `${xeropanApiUrl}/product_list${classroomPaymentKey}`;
  fetchData(endpointURL, 'GET', null, false).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getBraintreeClientToken = config => new Promise(((resolve, reject) => {
  const endpointURL = `${xeropanApiUrl}/braintree_client_token${classroomPaymentKey}`;
  fetchData(endpointURL, 'POST', config, false).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const verifyBraintreePayment = config => new Promise(((resolve, reject) => {
  const endpointURL = `${xeropanApiUrl}/payment${classroomPaymentKey}`;
  fetchData(endpointURL, 'POST', config, false).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getCountryList = () => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/purchase/countries`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const sendEnquiry = payload => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/purchase/enquiry`;
  fetchData(endpointURL, 'POST', payload).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const checkPreviousPurchase = email => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/purchase/checkPreviousPurchaseByEmail`;
  fetchData(endpointURL, 'POST', email).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const initiateCustomerAuth = email => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/purchase/initiateCustomerAuthentication`;
  fetchData(endpointURL, 'POST', email).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const pollCustomerAuth = requestToken => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/purchase/${requestToken}/poll`;
  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getPurchasesList = (page, orderKey, direction, limit) => new Promise(((resolve, reject) => {
  let endpointURL = `${apiURL}/api/purchase`;

  if (page !== undefined && orderKey !== undefined && direction !== undefined && limit !== undefined) {
    endpointURL = `${apiURL}/api/purchase/${page}?order=${orderKey}&direction=${direction}&limit=${limit}`;
  } else if (page !== undefined && orderKey !== undefined && direction !== undefined) {
    endpointURL = `${apiURL}/api/purchase/${page}?order=${orderKey}&direction=${direction}`;
  } else if (page !== undefined && orderKey !== undefined) {
    endpointURL = `${apiURL}/api/purchase/${page}?order=${orderKey}`;
  } else if (page !== undefined && limit !== undefined) {
    endpointURL = `${apiURL}/api/purchase/${page}?limit=${limit}`;
  } else if (page !== undefined) {
    endpointURL = `${apiURL}/api/purchase/${page}`;
  }

  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const getCouponsForPurchase = (purchaseId, orderKey, direction, term) => new Promise(((resolve, reject) => {
  let endpointURL = `${apiURL}/api/purchase/${purchaseId}/coupons`;

  if (orderKey !== undefined && direction !== undefined && term !== undefined) {
    endpointURL = `${apiURL}/api/purchase/${purchaseId}/coupons?order=${orderKey}&direction=${direction}&term=${term}`;
  } else if (orderKey !== undefined && direction !== undefined) {
    endpointURL = `${apiURL}/api/purchase/${purchaseId}/coupons?order=${orderKey}&direction=${direction}`;
  } else if (orderKey !== undefined) {
    endpointURL = `${apiURL}/api/purchase/${purchaseId}/coupons?order=${orderKey}`;
  } else if (term !== undefined) {
    endpointURL = `${apiURL}/api/purchase/${purchaseId}/coupons?term=${term}`;
  }

  fetchData(endpointURL, 'GET').then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const revokeCoupon = (purchaseId, coupons) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/purchase/${purchaseId}/coupons/revoke`;
  fetchData(endpointURL, 'POST', coupons).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));

const redeemCoupon = (purchaseId, data) => new Promise(((resolve, reject) => {
  const endpointURL = `${apiURL}/api/purchase/${purchaseId}/coupons/redeem`;
  fetchData(endpointURL, 'POST', data).then((result) => {
    resolve(result.data);
  }).catch((error) => {
    reject(error);
  });
}));


export default {
  getCountryList,
  getProductList,
  getBraintreeClientToken,
  verifyBraintreePayment,
  sendEnquiry,
  checkPreviousPurchase,
  initiateCustomerAuth,
  pollCustomerAuth,
  getExchangeRate,
  getPurchasesList,
  getCouponsForPurchase,
  revokeCoupon,
  redeemCoupon
};



// WEBPACK FOOTER //
// ./src/api/purchase.js